import { Language, Subsidiary } from '@coolblue-development/constants';

export const redirectToWebshopLeaseFlow = async (
  productId: number,
  language: Language,
  subsidiary: Subsidiary
) => {
  if (language === undefined) {
    language = Language.DUTCH;
  }
  if (subsidiary === undefined) {
    subsidiary = Subsidiary.NL;
  }

  const isDutch = language === Language.DUTCH;
  const isGerman = language === Language.GERMAN;

  const redirectUrl =
    subsidiary === Subsidiary.NL
      ? `https://www.coolblue.nl/switch-to-business?return=${isDutch ? '' : '/en'}/lease/store?product_id=${productId}`
      : subsidiary === Subsidiary.BE
        ? `https://www.coolblue.be/switch-to-business?return=/${language}/lease/store?product_id=${productId}`
        : `https://www.coolblue.de/switch-to-business?return=${isGerman ? '' : '/en'}/lease/store?product_id=${productId}`;

  try {
    window.location.href = redirectUrl;
  } catch (error) {
    console.error('Failed to redirect and continue the lease flow:', error);
  }
};
